import { LEAD_STATUSES } from "../../../Lead/constants/lead-statuses.ts"

/**
 * Lifecycle order, not numeric order — Booked/Exploration/Contract were added
 * to the enum after Estimate/Won and sort out of sequence. Mirrors the
 * backend's `LIFECYCLE_ORDER` in `apps/crm/lifecycle.py` exactly.
 */
export const LIFECYCLE_STAGE_VALUES = [
  LEAD_STATUSES.NEW,
  LEAD_STATUSES.CONTACTED,
  LEAD_STATUSES.BOOKED,
  LEAD_STATUSES.EXPLORATION,
  LEAD_STATUSES.ESTIMATE,
  LEAD_STATUSES.CONTRACT,
  LEAD_STATUSES.WON
] as const

export const LIFECYCLE_STAGE_LABELS: Record<number, string> = {
  [LEAD_STATUSES.NEW]: "New",
  [LEAD_STATUSES.CONTACTED]: "Contacted",
  [LEAD_STATUSES.BOOKED]: "Booked",
  [LEAD_STATUSES.EXPLORATION]: "Exploration",
  [LEAD_STATUSES.ESTIMATE]: "Estimate",
  [LEAD_STATUSES.CONTRACT]: "Contract",
  [LEAD_STATUSES.WON]: "Won"
}

export const lifecycleStageIndex = (stage: number | null): number =>
  stage === null ? -1 : LIFECYCLE_STAGE_VALUES.indexOf(stage as never)
